import { useState, useEffect } from 'react';
import { Row, Divider,  PageHeader, Table, Space, message, Button }  from 'antd';
import { DeleteOutlined } from '@ant-design/icons'
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import SalesAdd from './SalesAdd';
import SalesUpdate from './SalesUpdate';
import moment from 'moment';
import axios from 'axios';


const Sales = ()=>{

    const [salesData, setSalesData] = useState()

    const getAllSales = () =>{
        let getSales = `${FetchVariable.Heroku}/sales/get-all-sales`
        axios.get(getSales)
            .then((res)=>{
                let data =res.data
                setSalesData(data)
            })
    };
            
    function deleteSale (deleteID){
            let deleteSale = `${FetchVariable.Heroku}/sales/`+deleteID
            axios.delete(deleteSale)
                .then(() => {
                    getAllSales()
                    message.error('The Sale is deleted')
            })
    };

    const addSales = (addSalesData)=>{
        addSalesData.SalesDate = moment(addSalesData.SalesDate).format("YYYY-MM-DD")
            let apiURL = `${FetchVariable.Heroku}/sales/`
            axios.post(apiURL, addSalesData)
            .then(res=>
                {
                    if(res.data.error){
                        message.error(res.data.error);
                }else{
                    getAllSales()
                }}
            ).catch(err=>{console.log(err)})
    };

    const updateSales = (updateSales)=>{
            let apiURL = `${FetchVariable.Heroku}/sales/`
            axios.put(apiURL, updateSales)
            .then(res=>
                {
                    if(res.data.error){
                        let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                        message.error(errorMessage,10);
                }
            else{
                getAllSales()
            }}
            ).catch(err=>{console.log(err)})
    };

    useEffect(() => {
        getAllSales();
    }, [])

    //Helper function to dynamically render our filter
    const filterData = data => formatter => data?.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const SalesColumns = [
    {
        title: 'Sales ID',
        dataIndex: 'SalesID',
        key: 'SalesID',
        sorter: (a, b) => a.SalesID - b.SalesID,
        sortDirections: ['descend','ascend'],
    },
    {
        title: 'Payment Method',
        dataIndex: 'PaymentMethod',
        key: 'PaymentMethod',
        
    },
    {
        title: 'Sales Date',
        dataIndex: 'SalesDate',
        key: 'SalesDate',
    },
    {
        title: 'Customer Name',
        dataIndex: 'CustomerName',
        key: 'CustomerName',
        filters: filterData(salesData)(i => i.CustomerName),
        width:250,
        filterSearch: true,
        onFilter: (value, record) => record.CustomerName.indexOf(value) === 0,
        sorter: (a, b) => a.CustomerName.length - b.CustomerName.length,
        sortDirections: ['descend','ascend'],
    },
    {
        title: 'Make',
        dataIndex: 'Make',
        key: 'Make',
    },
    {
        title: 'Model',
        dataIndex: 'Model',
        key: 'Model',
    },
    {
        title: 'Vehicle Year',
        dataIndex: 'VehicleYear',
        key: 'VehilceYear',
        
    },
    {
        title: 'Vehicle VIN',
        dataIndex: 'VehicleVIN',
        key: 'VehicleVIN',
        filters: filterData(salesData)(i => i.VehicleVIN),
        width:200,
        filterSearch: true,
        onFilter: (value, record) => record.VehicleVIN.indexOf(value) === 0,
        sorter: (a, b) => a.VehicleVIN.length - b.VehicleVIN.length,
        sortDirections: ['descend','ascend'],
    },
    {
        title: 'Action',
        key: 'action',
        render: (record) => (
            <Space size="middle">
            <SalesUpdate record={record} updateSales={updateSales}/>
            <Button onClick={()=> deleteSale(record.SalesID) } type="primary" danger icon={<DeleteOutlined />}></Button>
            </Space>
        ),
        },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Sales Management"
            extra={[ 
                <SalesAdd key='addSales' addSales={addSales}/>,
            ]}
            >
            </PageHeader>

            <Divider />
            <Row>
                <Table 
                columns={SalesColumns} 
                dataSource={salesData} 
                rowKey={(record)=>record.SalesID}
                scroll={{ x: 1500, y: 800 }} 
                />
                
            </Row>
        </>
    )
}

export default Sales